exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".gettingStarted--row--22RNArCO {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.gettingStarted--col--2H5_ecEu {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.gettingStarted--col--2H5_ecEu > a > img {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/views/gettingStarted/gettingStarted.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,UAAU;CACX;;AAED;EACE,WAAW;EACX,UAAU;CACX;;AAED;EACE,YAAY;EACZ,aAAa;CACd","file":"gettingStarted.css","sourcesContent":[".row {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.col {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.col > a > img {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"row": "gettingStarted--row--22RNArCO",
	"col": "gettingStarted--col--2H5_ecEu"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/views/gettingStarted/gettingStarted.css
// module id = 438
// module chunks = 0